var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgListZoom = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 3.5C9.82608 3.5 11.0979 4.02678 12.0355 4.96447C12.9732 5.90215 13.5 7.17392 13.5 8.5C13.5 9.82608 12.9732 11.0979 12.0355 12.0355C11.0979 12.9732 9.82608 13.5 8.5 13.5C7.17392 13.5 5.90215 12.9732 4.96447 12.0355C4.02678 11.0979 3.5 9.82608 3.5 8.5C3.5 7.17392 4.02678 5.90215 4.96447 4.96447C5.90215 4.02678 7.17392 3.5 8.5 3.5ZM8.5 15C10.025 15 11.4281 14.475 12.5344 13.5969L16.7188 17.7812C17.0125 18.075 17.4875 18.075 17.7781 17.7812C18.0688 17.4875 18.0719 17.0125 17.7781 16.7219L13.5969 12.5344C14.475 11.4281 15 10.025 15 8.5C15 4.90937 12.0906 2 8.5 2C4.90937 2 2 4.90937 2 8.5C2 12.0906 4.90937 15 8.5 15ZM7.75 11.25C7.75 11.6656 8.08437 12 8.5 12C8.91563 12 9.25 11.6656 9.25 11.25V9.25H11.25C11.6656 9.25 12 8.91563 12 8.5C12 8.08437 11.6656 7.75 11.25 7.75H9.25V5.75C9.25 5.33437 8.91563 5 8.5 5C8.08437 5 7.75 5.33437 7.75 5.75V7.75H5.75C5.33437 7.75 5 8.08437 5 8.5C5 8.91563 5.33437 9.25 5.75 9.25H7.75V11.25Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgListZoom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "faf856754c7d94dd87c17b16063549ae.svg";